const initialColorSelector = () => {
  const hex2rgba = (hex: string, alpha = 0.08) => {
    const r = parseInt(hex.substring(1, 3), 16);
    const g = parseInt(hex.substring(3, 5), 16);
    const b = parseInt(hex.substring(5, 7), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  ["turbo:load", "turbo:render"].forEach((event) => {
    document.addEventListener(event, () => {
      const colorField = <HTMLInputElement>document.getElementById("color-selector-field");
      const optionsBox = document.getElementById("color-selector-options");

      const example = document.getElementById("color-selector-example");

      if (!colorField || !optionsBox || !example) return;

      const setExampleColor = (value) => {
        example.style.color = value;
        example.style.border = `medium solid ${value}`;
        example.style.background = hex2rgba(value);
      };

      Array.from(optionsBox.children).forEach((button) => {
        button.addEventListener("click", (e) => {
          const value = (e.target as HTMLButtonElement).textContent.trim();
          if (value === null) return;

          colorField.value = value;
          setExampleColor(value);
        });
      });

      colorField.addEventListener("input", (e) => {
        const value = (e.target as HTMLInputElement).value;
        setExampleColor(value);
      });
    });
    ["turbo:load", "turbo:render"].forEach((event) => {
      document.addEventListener(event, () => {
        const hasColorCheck = document.getElementById("has_color");
        const colorSelector = document.getElementById("color-selector");
        if (!hasColorCheck || !colorSelector) return;

        const colorField = colorSelector.querySelector("input");
        if (!colorField) return;

        const updateColorSelectorDisplay = () => {
          const hasColorCheck = <HTMLInputElement>document.getElementById("has_color");
          colorSelector.style.display = hasColorCheck.checked ? "block" : "none";
          colorField.disabled = !hasColorCheck.checked;
        };

        hasColorCheck.addEventListener("change", () => updateColorSelectorDisplay());
        updateColorSelectorDisplay();
      });
    });
  });
};

export default initialColorSelector;
